import { render, staticRenderFns } from "./MudarDeDepartamentoDialog.vue?vue&type=template&id=2e4047eb&scoped=true"
import script from "./MudarDeDepartamentoDialog.vue?vue&type=script&lang=js"
export * from "./MudarDeDepartamentoDialog.vue?vue&type=script&lang=js"
import style0 from "./MudarDeDepartamentoDialog.vue?vue&type=style&index=0&id=2e4047eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4047eb",
  null
  
)

export default component.exports